import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const UserProfile = MatxLoadable({
    loader: () =>
        import ("./UserProfile")
})
const AllUserProfile = MatxLoadable({
    loader: () =>
        import ("./AllUserProfile")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const UserProfileRoutes = [
    {
        path: "/dashboard/user/profile",
        component: AllUserProfile,
        // settings
    },

];

export default UserProfileRoutes;